// Upload-Lift owns uploads/properties. This guard requires a completed original
// upload on reusable photo-gift templates, even when app targeting is missing.
class PersonalizedUploadValidation extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.details = this.closest('.product-details');
    this.error = this.querySelector('[data-upload-error]');
    if (!this.details || !this.error) return;
    this.uploads = new window.LaPhotoUploadCompletion(this.details, signal, () => {
      this.error.hidden = true;
      this.error.textContent = '';
    });
    const submit = event => {
      const form = document.getElementById(this.dataset.formId);
      const button = event.type === 'click' ? event.target.closest('button[type=submit], input[type=submit]') : null;
      if (!form || (event.type === 'click' ? button?.form !== form : event.target !== form)) return;
      if (this.uploads.ready(new FormData(form))) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.error.textContent = 'Please complete your pet-photo upload before adding this item to your cart.';
      this.error.hidden = false;
      this.error.focus();
    };
    window.addEventListener('click', submit, { capture: true, signal });
    window.addEventListener('submit', submit, { capture: true, signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('la-upload-validation')) customElements.define('la-upload-validation', PersonalizedUploadValidation);
